/* eslint-disable indent */
/* eslint-disable multiline-ternary */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable camelcase */
import React, { useEffect } from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import { PropTypes } from 'prop-types'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { useDispatch, useSelector } from 'react-redux'
import InputBase from '@mui/material/InputBase'
import Divider from '@mui/material/Divider'
import CloseIcon from '@mui/icons-material/Close'
import Paper from '@mui/material/Paper'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import { FormGroup, InputAdornment, IconButton } from '@mui/material'
import {
  setShareableIntroModalShownOnce,
  setShowCopyLinkModal,
  setShowStreetmixIntroModal,
  setShareableURLSearchParam,
  setShowLanduseErrModal,
  setShowConfirmDeleteModal,
  setShowNoFeatureSelectedModal,
  setShowErrAddingFeatureToProjectModal,
  setShowErrRemovingFeatureFromProjectModal,
  setShowResetTiersModal,
  setShowClearSegmentsStartManualModal
} from '../slices/appSlice'
import { setStartStreetmixTour } from '../slices/tourSlice'
import { themeConfig } from '../config/theme.config'
import CustomButton from './CustomButton'
import { SectionTitle, SubSectionTitle } from './ProjectInputs/ProjectInputs'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '40vw',

  bgcolor: 'background.paper',
  outline: 'none !important',
  boxShadow: 24,
  p: 4,
  display: 'flex',
  flexDirection: 'column',
  gap: '6px'
}

export default function CustomModal({
  title,
  btnText,
  handleBtnClick,
  modalContent,
  showTakeTour = false,
  showDoNotShowAgain = false,
  showCancelBtn = false,
  modifiedModalContent = null,
  justifyContent = 'center'
}) {
  const [open, setOpen] = React.useState(true)
  const { roadway_name } = useSelector((state) => state.roadwayVariables)
  const { shareableURLSearchParam, manualStreetMode } = useSelector(
    (state) => state.appSlice
  )

  const [checked, setChecked] = React.useState(false)
  const { showCopyLinkModal } = useSelector((state) => state.appSlice)

  const dispatch = useDispatch()
  const handleClose = () => {
    setOpen(false)
    dispatch(setShareableIntroModalShownOnce(true))
    dispatch(setShowCopyLinkModal(false))
    dispatch(setShowStreetmixIntroModal(false))
    dispatch(setShowLanduseErrModal(false))
    dispatch(setShowConfirmDeleteModal(false))
    dispatch(setShowClearSegmentsStartManualModal(false))
    dispatch(setShowNoFeatureSelectedModal(false))
    dispatch(setShowErrAddingFeatureToProjectModal(false))
    dispatch(setShowErrRemovingFeatureFromProjectModal(false))
    dispatch(setShowResetTiersModal(false))
  }
  const handleClick = () => {
    setOpen(false)
    handleBtnClick()
  }

  useEffect(() => {
    dispatch(setShareableURLSearchParam(roadway_name))
  }, [roadway_name])

  function handleChange(e) {
    dispatch(setShareableURLSearchParam(e.target.value))
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{ zIndex: 1000020 }}
    >
      <Box sx={{ ...style }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <SectionTitle>{title}</SectionTitle>
          <IconButton
            sx={{
              color: themeConfig.semcogBlue1,
              alignSelf: 'center',
              '& .MuiSvgIcon-root': { fontSize: '1.5rem' }
            }}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        {modifiedModalContent ? (
          modifiedModalContent
        ) : (
          <SubSectionTitle fontWeight={400} fontSize={14}>
            {modalContent}
          </SubSectionTitle>
        )}
        {showCopyLinkModal && (
          <Paper
            component="form"
            sx={{
              p: '2px 4px',
              display: 'flex',
              alignItems: 'center',
              width: '100%'
            }}
          >
            <InputBase
              sx={{ ml: 1, flex: 1, width: '90%' }}
              startAdornment={
                <InputAdornment
                  position="start"
                  sx={{ marginRight: '1px !important' }}
                >
                  {!window.location.toString().includes('/shareable')
                    ? window.location.toString() + '/shareable?prj_name='
                    : window.location.toString()}
                </InputAdornment>
              }
              value={shareableURLSearchParam}
              onChange={handleChange}
              autoFocus={true}
              inputProps={{ 'aria-label': 'search google maps' }}
            />

            <Divider
              sx={{ height: 28, m: 0.5, width: '1%' }}
              orientation="vertical"
            />
            <IconButton
              color="primary"
              sx={{ p: '10px' }}
              aria-label="directions"
              onClick={handleClick}
            >
              <ContentCopyIcon />
            </IconButton>
          </Paper>
        )}
        <Box
          sx={{
            width: '100%',

            display: 'flex',
            justifyContent: justifyContent,
            alignItems: 'center',
            gap: '50px'
          }}
        >
          {showTakeTour && (
            <CustomButton
              btnLabel="Take the Tour"
              handleNext={() => {
                handleClose()
                dispatch(setStartStreetmixTour(true))
              }}
            />
          )}

          <CustomButton btnLabel={btnText} handleNext={handleClick} />
          {/* {showCancelBtn && (
            <CustomButton
              btnLabel="Cancel"
              handleNext={() => {
                handleClose()
              }}
            />
          )} */}
        </Box>
        {showDoNotShowAgain && (
          <Box
            sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}
          >
            <FormGroup sx={{ m: '0.5em' }}>
              <FormControlLabel
                sx={{
                  '& .MuiTypography-root': {
                    color: themeConfig.semcogBlack,
                    fontSize: '14px'
                  }
                }}
                control={
                  <Checkbox
                    checked={checked}
                    onChange={() => {
                      setChecked(!checked)
                      localStorage.setItem('showStreetmixIntroModal', checked)
                      console.log(
                        localStorage.getItem('showStreetmixIntroModal'),
                        'intro'
                      )
                    }}
                  />
                }
                label="Do not show this dialog again"
              />
            </FormGroup>
          </Box>
        )}
      </Box>
    </Modal>
  )
}
CustomModal.propTypes = {
  title: PropTypes.string,
  btnText: PropTypes.string,
  handleBtnClick: PropTypes.func,
  modalContent: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  showTakeTour: PropTypes.bool,
  showDoNotShowAgain: PropTypes.bool,
  showCancelBtn: PropTypes.bool,
  modifiedModalContent: PropTypes.node,
  justifyContent: PropTypes.string
}
